import React, {useEffect, useState} from 'react';
import { Card, } from "@material-ui/core";
import {Col, Row} from "reactstrap";
import {
    bbDangerousStringToDate,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbShortenString,
} from "../../../util/bbHelpers";
import SimpleNumberCard from "../metrics/SimpleNumberCard";
import BRThreatsSummaryTableThreatsStatusProgress from "../BreachRiskReport/BRThreatsSummaryTableThreatsStatusProgress";
import VectorScopeToggle from "../BreachRiskReport/VectorScopeToggle";
import VectorComments from "../BreachRiskReport/VectorComments";
import VectorClientStatusSelect from "../BreachRiskReport/VectorClientStatusSelect";
import {useDispatch, useSelector} from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import BBLogo from "../../../assets/images/logo-black.svg";
import BBExternalLink from "../accents/BBExternalLink";
import {fetchVectorResults} from "../../../actions";
import {CircularProgress} from "@mui/material";
import Skeleton from "react-loading-skeleton";

const BRBusinessVectorCards = ({vector = null,
                                   threatVector= null,
                                   entityId=null,
                                   target=null,
                               isOpen = false,})=>{

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, loadingVectorResults, loadingVectorResultsError,} = useSelector(({breachrisk})=> breachrisk);
    const customerId = customers ? customerInView ? customerInView : null : null;
    const dispatch = useDispatch();

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityId, portfolios, customerId);
    const lastCycle = myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;
    const lastCycleDate = lastCycle && lastCycle.summary && lastCycle.summary.cycle_datetime ? bbDangerousStringToDate(lastCycle.summary.cycle_datetime) : null

    const vectorScore = vector && vector.score

    const testedVectorDetails = vector && vector.tested_vector_details
// console.log("this si vector for this card", vector);

    const vectorDefinition = vector && vector.definition;
    const vectorDefinitionDescription = vectorDefinition && vectorDefinition.description;
    const vectorDefinitionService = vectorDefinition && vectorDefinition.service;
    const vectorDefinitionName = vectorDefinition && vectorDefinition.name;
    const vectorDefinitionTypeDescription = vectorDefinition && vectorDefinition.type && vector.definition.type.description;

    const results = testedVectorDetails && testedVectorDetails.results ? testedVectorDetails.results : null;

    const [vectorHasUpdatedResults, setVectorHasUpdatedResults] = useState(!!(results));

    const hasResults = vectorHasUpdatedResults && results && Object.keys(results).length > 0;

    useEffect(()=>{
        if(isOpen){
            if (!loadingVectorResults[vector.id]
                && !loadingVectorResults[vector.id]
                && vector
                && testedVectorDetails
                && !hasResults) {
                dispatch(fetchVectorResults(entityId, customerId, vector.cycle ,vector.id))
                setVectorHasUpdatedResults(results && Object.keys(results).length > 0);
            }
        }
        setVectorHasUpdatedResults(results && Object.keys(results).length > 0);

    }, [results, loadingVectorResults, loadingVectorResultsError, hasResults, vectorHasUpdatedResults])


    const totalAttacks = hasResults && results.total_attacks ? results.total_attacks : 0;
    const successfulAttacks = hasResults && results.total_attacks_successful ? results.total_attacks_successful : 0;
    const defeatedAttacks = hasResults && results.total_attacks_defeated ? results.total_attacks_defeated : 0;

    const fqdnShort = target && target.Fqdn
        ? Array.isArray(target.Fqdn)
            ? target.Fqdn.length > 0
                ? <Tooltip title={`${target.Fqdn.join(", ")}`}><span>{bbShortenString(target.Fqdn.join(", "), 50, true)}</span></Tooltip>
                : "None detected"
            : <Tooltip title={`${target.Fqdn}`}><span>{bbShortenString(target.Fqdn, 50, true)}</span></Tooltip>
        : "None detected"

    console.log("This vector has results", hasResults, "print results object", results, "loadingVectorResults", loadingVectorResults, "loadingVectorResultsError", loadingVectorResultsError, "vectorhasUpdatedResults", vectorHasUpdatedResults,
        "various attack numbers-- totals", totalAttacks, "successfulAttacks", successfulAttacks, "defatedAttacks", defeatedAttacks);

    return(
            <Col >
                <div style={{backgroundImage: `url(${BBLogo})`, margin: "auto", width: "250px", backgroundRepeat: "no-repeat", height: "55px"}} className={"d-none d-print-block"}><></></div>
                {!loadingVectorResults[vector.id]
                    && !loadingVectorResultsError[vector.id]
                    && vectorHasUpdatedResults
                    ?<Card className={"p-0 m-0"}>
                    <Row>
                        <Col lg={8} className={"text-center d-print-inline"}>
                            <Row>
                                <h1 className={"col-12 m-1 p-1"} style={{width: "100%"}}>{vectorDefinitionName}</h1>
                            </Row>
                            <Row className={"col-12 text-center card-text m-1 darken-1"}>
                                <p style={{width: "100%", textAlign: "center"}}>{vectorDefinitionDescription}</p>
                            </Row>
                            <Row>
                                <Col lg={1}/>
                                <Col className={"text-left"}>
                                    <em>
                                        First Observed: { testedVectorDetails && testedVectorDetails.created_datetime
                                        ? bbFormattedDateString(testedVectorDetails.created_datetime, "shortFullMonth")
                                        : "--"}
                                    </em>
                                </Col>
                                <Col className={"text-right"}>
                                    <em>
                                        Last Observed: { lastCycleDate
                                        ? bbFormattedDateString(lastCycleDate, "shortFullMonth")
                                        : "--"}
                                    </em>
                                </Col>
                                <Col lg={1}/>
                            </Row>
                            <Row>
                                <Col>
                                    <SimpleNumberCard number={!hasResults && loadingVectorResults[vector.id] ? <CircularProgress/> : successfulAttacks} title={"Successful Attacks"} />

                                </Col>
                                <Col>
                                    <SimpleNumberCard number={!hasResults && loadingVectorResults[vector.id] ? <CircularProgress/> : totalAttacks } title={"Attacks"} />
                                </Col>
                                <Col>
                                    <SimpleNumberCard number={!hasResults && loadingVectorResults[vector.id] ? <CircularProgress/> : defeatedAttacks} title={"Defeated Attacks"}/>
                                </Col>
                            </Row>
                            <Row className={"m-1 p-1"}>
                                <Col/>
                                <Col lg={10}>
                                    <BRThreatsSummaryTableThreatsStatusProgress currentStep={vector.stepStatus} vectorCard vector={vector}/>
                                </Col>
                                <Col/>
                            </Row>
                            <Row>
                                <Col lg={1}/>
                                <Col className={"text-left"}>
                                    <em>
                                        Last Test: { testedVectorDetails && testedVectorDetails.last_test_conducted
                                        ? bbFormattedDateString(testedVectorDetails.last_test_conducted, "shortFullMonth")
                                        : "--"}
                                    </em>
                                </Col>
                                <Col lg={1}/>
                            </Row>

                        </Col>

                        <br className={"d=none d-print-block"}/>

                        <Col lg={4} className={"text-left bg-grey lighten-3 p-0 d-print-inline"}>
                            <Row><Col lg={12}><br/></Col></Row>
                            <Row className={"d-print-inline"}>
                                <Col lg={12} className={"text-center"}>
                                    {vectorScore &&
                                    <div className={"text-center d-inline d-print-inline"}>
                                        <h3 className={"d-inline text-center"}>
                                            <strong>
                                                {vectorScore}
                                            </strong>
                                        </h3>
                                        <p className={"d-inline d-print-inline text-grey"}>
                                            <small>
                                                /10
                                            </small>
                                        </p>
                                        <p className={"text-grey"} >Danger Level</p>
                                    </div>
                                    }
                                </Col>
                            </Row>
                                <Row className={"p-0 d-print-inline"} style={{marginTop: "-4%"}}>
                                    <Col lg={2}> </Col>
                                    {vectorScore  && <Col lg={4} className={"text-left"}>
                                            <h4 className={"d-inline d-print-inline"}>
                                                    {vector && vector.likelihood_score ? vector.likelihood_score : "--"}
                                            </h4>
                                            <p className={"d-inline d-print-inline text-grey m-0 p-0"}>
                                                <small>
                                                    /5
                                                </small>&nbsp;
                                                Likelihood
                                            </p>
                                    </Col>
                                        }
                                    {vectorScore && <Col lg={4} className={"text-right"}>
                                            <h4 className={"d-inline d-print-inline"}>
                                                {vector && vector.impact_score? vector.impact_score : "--"}
                                            </h4>
                                            <p className={"d-inline text-grey d-print-inline"}>
                                                <small>
                                                    /5
                                                </small>&nbsp;
                                                Impact
                                            </p>
                                        </Col>
                                        }
                                    <Col lg={2}> </Col>

                                </Row>
                            <div className={"m-1 p-1 d-print-block"}>
                                <Row className={"border-bottom d-print-table-cell"}>
                                    <Col lg={4} className={"text-center"}>
                                        <span style={{fontSize: "12px"}}>Origin IP Address</span>
                                    </Col>
                                    <Col lg={8} className={"text-left align-self-center"}>
                                        {target && target.IpAddress ? target.IpAddress : "--"}
                                    </Col>
                                </Row>
                                <Row className={"border-bottom align-self-center d-print-table-cell"}>
                                    <Col lg={4} className={"text-right"}>
                                        <span style={{fontSize: "12px"}}>URL</span>
                                    </Col>
                                    <Col lg={8} className={"text-left align-self-center"}>
                                        <code><small>{vector && vector.url ? vector.url : "--"}</small></code>
                                    </Col>
                                </Row>
                                <Row className={"border-bottom d-print-table-cell"}>
                                    <Col lg={4} className={"text-right"}>
                                        <span style={{fontSize: "12px"}}>Domain (FQDN)</span>
                                    </Col>
                                    <Col lg={8} className={"text-left align-self-center"}>
                                        {fqdnShort ? fqdnShort : "--"}
                                    </Col>
                                </Row>
                                <Row className={"border-bottom d-print-table-cell"}>
                                    <Col lg={4} className={"text-right align-self-center"}>
                                        <span style={{fontSize: "12px"}}>Operating System</span>
                                    </Col>
                                    <Col lg={8} className={"text-left text-nowrap p-2 align-self-center "}>
                                        {( target && target.OsDetails && target.OsDetails.Logo) ? (
                                            <p className={""}><img style={{height: 18}} src={target.OsDetails.Logo} alt={`${bbShortenString(target.OsDetails.Name, 25, true)}`} />
                                         &nbsp;{target.Os}</p>)
                                        : "--"}
                                    </Col>
                                </Row>
                                <Row className={"border-bottom d-print-table-cell"}>
                                    <Col lg={4} className={"text-right align-self-center"}>
                                        <span style={{fontSize: "12px"}}>Type</span>
                                    </Col>
                                    <Col lg={8} className={"text-left text-nowrap p-2"}>
                                            { vectorDefinitionTypeDescription ? vectorDefinitionTypeDescription : "--"}
                                    </Col>
                                </Row>
                                <Row className={"border-bottom d-print-table-cell"}>
                                    <Col lg={4} className={"text-right align-self-center"}>
                                        <span style={{fontSize: "12px"}}>Service</span>
                                    </Col>
                                    <Col lg={8} className={"text-left p-2"}>
                                        {vectorDefinitionService ? vectorDefinitionService : "--"}
                                    </Col>
                                </Row>
                                <Row className={"border-bottom d-print-table-cell"}>
                                    <Col lg={4} className={"text-right align-self-center"}>
                                        <span style={{fontSize: "12px"}}>CVEs Present</span>
                                    </Col>
                                    <Col lg={8} className={"text-left p-2"}>
                                        {target && target.Vulnerabilities && Array.isArray(target.Vulnerabilities) && target.Vulnerabilities.length > 0
                                        ? target.Vulnerabilities.map((vuln, index)=> (
                                        <>
                                            <BBExternalLink
                                                key={`${vuln}${index}`}
                                                href={`https://nvd.nist.gov/vuln/detail/${vuln}`}
                                                tipText={`This CVE is present at this location, but may not be related to the Threat Vector. Read more about ${vuln} at the NIST National Vulnerability Database.`}
                                            >
                                                {vuln}
                                            </BBExternalLink>
                                            &nbsp;
                                        </>
                                       ))
                                        : <span> -- </span>
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <Row className={"text-center align-self-center d-print-none"}>
                                <Col lg={12}>
                                    Actions
                                </Col>
                            </Row>
                            <Row className={"text-center align-self-center d-print-none"}>
                                <Col lg={2}/>
                                <Col className={"m-0 p-0"}>
                                    <VectorScopeToggle cycleId={vector.cycle}
                                                       customerId={customerId}
                                                       vectorId={vector.id}
                                                       testedVectorId={testedVectorDetails.id}
                                                       entityId={entityId}/>
                                </Col>
                                <Col className={"m-0 p-0"}>
                                    <VectorComments cycleId={vector.cycle}
                                                    customerId={customerId}
                                                    vectorId={vector.id}
                                                    testedVectorId={testedVectorDetails.id}
                                                    entityId={entityId}/>
                                </Col>
                                <Col className={"m-0 p-0"}>
                                    <VectorClientStatusSelect customerId={customerId}
                                                              vectorId={vector.id}
                                                              cycleId={vector.cycle}
                                                              testedVectorId={testedVectorDetails.id}
                                                              entityId={entityId}/>
                                </Col>
                                <Col lg={2}/>
                            </Row>
                        </Col>
                    </Row>
                </Card>
                :<Card className={"m-0 p-0 animated fadeIn animation-duration-12"}>
                    <div className={"card-header"} style={{width:"100%"}}>
                    Loading Threat Vector Details...
                    <Row>
                    <Col>
                    <h2>
                    <Skeleton count={6}/>
                    </h2>
                    </Col>
                    </Row>
                    </div>
                    </Card>}
            </Col>
    )
}

export default BRBusinessVectorCards;